//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Tooltip,
} from '@mui/material';
import {
  ArrowBack,
  NavigateBefore,
  NavigateNext,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {Spacer} from 'components/Spacer';
import { Menu } from 'pages/Menu';
import ReviewStatusSelect from './components/ReviewStatusSelect/ReviewStatusSelect';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext';

// === API ===

//#endregion

//-----------------------------------------------------------------
export function HeaderTaskView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const { file_id, file_name, task, document_current, getPrevDocument, getNextDocument } = useAnalytics();

  //#endregion

  //#region [STYLES]

  const _styles = {
    button_back: {
      height: '40px',
      margin: '0 6px',
    },
  }

  const tooltip_font_large = {
    slotProps: {
      tooltip: {
        sx: {
          fontSize: '14px', // Set your custom size here
        },
      },
    }
  }

  const BUTTON_PREV = {
    sx       : _styles.button_back,
    variant  : 'contained',
    color    : 'primary',
    onClick  : () => { getPrevDocument() },
    children : <NavigateBefore fontSize='large'/>,
    name     : 'da_document_prev_btn',
  };

  const BUTTON_NEXT = {
    sx       : _styles.button_back,
    variant  : 'contained',
    color    : 'primary',
    onClick  : () => { getNextDocument() },
    children : <NavigateNext fontSize='large'/>,
    name     : 'da_document_next_btn',
  };

  const BUTTON_BACK = {      
    sx       : _styles.button_back,
    variant  : 'contained',
    color    : 'error',
    onClick  : () => { navigate( '/analytics/files/' + file_id ) },
    children : <ArrowBack fontSize='large'/>,
    name     : 'da_close_task_view_btn',
  };

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
    if( document_current === '' ) return;

    setSearchParams( { document: document_current } )
  }, [document_current] );

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Menu>
        <Styled styles={[ {display: 'flex'}, {alignItems:'center'}]}>
          <Styled styles={[{ display: 'flex' }, {width:'fit-content', height: 'fit-content'}, { padding: '4px 8px 4px 8px' }, { gap: '12px'}, { alignItems: 'center'} ]}>
            <div style={{ fontSize: '22px', color: theme.palette.primary.main }}>{file_name + ' -'}</div>
            <div style={{ fontSize: '22px' }}>{task?.document}</div>
          </Styled>
          <Spacer push_right />
          <ReviewStatusSelect />
          <Tooltip title="Previous Document" { ...tooltip_font_large } >
            <Button { ...BUTTON_PREV } />
          </Tooltip>
          <Tooltip title="Next Document" { ...tooltip_font_large } >
            <Button { ...BUTTON_NEXT } />
          </Tooltip>
          <Tooltip title="Go Back" { ...tooltip_font_large } >
            <Button { ...BUTTON_BACK } />
          </Tooltip>
        </Styled>
      </Menu>
    )
  }

  //#endregion

  return display();
}
